export default __webpack_public_path__ + "static/media/CS-RaceWeek-Brasil(1440x600).24cb2301.webp";